import { render, staticRenderFns } from "./PadoPlayerTurnOrderComponent.vue?vue&type=template&id=65fee225&scoped=true"
import script from "./PadoPlayerTurnOrderComponent.vue?vue&type=script&lang=ts"
export * from "./PadoPlayerTurnOrderComponent.vue?vue&type=script&lang=ts"
import style0 from "./PadoPlayerTurnOrderComponent.vue?vue&type=style&index=0&id=65fee225&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fee225",
  null
  
)

export default component.exports